// URL base da API
const API_BASE_URL = process.env.REACT_APP_API_URL;

// Função auxiliar para obter o token de autenticação do localStorage
const getAuthToken = (): string | null => {
  try {
    return localStorage.getItem('authToken');
  } catch (error) {
    console.error('Erro ao obter token de autenticação:', error);
    return null;
  }
};

// Função para criar headers com token de autenticação
const getAuthHeaders = (): HeadersInit => {
  const token = getAuthToken();
  const headers: HeadersInit = {};

  if (token) {
    headers['Authentication'] = `Bearer ${token}`;
    headers['Authorization'] = `Bearer ${token}`;
  } else {
    console.warn('Token de autenticação não encontrado no localStorage');
  }

  return headers;
};

const getBackendErrorMessage = async (response: Response, fallbackMessage: string): Promise<string> => {
  try {
    const contentType = response.headers.get('content-type') || '';
    if (contentType.includes('application/json')) {
      const data = await response.json();
      if (data && typeof data === 'object') {
        const anyData = data as any;
        const message = typeof anyData.message === 'string' ? anyData.message
          : typeof anyData.Mensagem === 'string' ? anyData.Mensagem
          : undefined;
        if (message && message.trim()) return message;
      }
    } else {
      const text = await response.text();
      if (text && text.trim()) return text;
    }
  } catch {
    // Ignorar falha ao ler body; usar fallback
  }

  return fallbackMessage;
};

// Concessionária que o usuário master pode escolher para impersonar
export interface DealerSummary {
  id: string;
  name: string;
  cnpj: string;
  dealerNetworkId: string;
  dealerNetworkName: string;
}

// Resposta do endpoint de impersonação: token da concessionária escolhida
export interface ImpersonateResponse {
  token: string;
  dealerId: string;
  dealerName: string;
  dealerCnpj: string;
}

export const masterService = {
  /**
   * Lista as concessionárias ativas que o usuário master pode impersonar
   */
  listDealers: async (): Promise<DealerSummary[]> => {
    const response = await fetch(`${API_BASE_URL}/api/v1/master/dealers`, {
      method: 'GET',
      headers: getAuthHeaders(),
    });

    if (!response.ok) {
      throw new Error(await getBackendErrorMessage(response, 'Não foi possível carregar a lista de concessionárias.'));
    }

    return response.json();
  },

  /**
   * Solicita um token com a identidade da concessionária escolhida
   */
  impersonate: async (dealerId: string): Promise<ImpersonateResponse> => {
    const response = await fetch(`${API_BASE_URL}/api/v1/master/impersonate/${dealerId}`, {
      method: 'POST',
      headers: getAuthHeaders(),
    });

    if (!response.ok) {
      throw new Error(await getBackendErrorMessage(response, 'Não foi possível acessar essa concessionária.'));
    }

    return response.json();
  },
};
